/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { Injectable } from '@angular/core';
import permissions from '../../assets/json/permissions.json';
import { HttpHeaders } from '@angular/common/http';
import { resetInitialState } from '../store/app.actions';
import { Store } from '@ngrx/store';
import { UserInfo, DocsService, DOCS_PATHS, AppInfoService } from '@foglight/angular-common';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor(private store: Store,
    private docsService: DocsService,
    private appInfoService: AppInfoService) {}

  clearBreadCrumbHistory(): void {
    sessionStorage.setItem('breadcrumbHistory', JSON.stringify([]));
  }

  clearSessionOnLogOut(): void {
    this.store.dispatch(resetInitialState());
    window.sessionStorage.removeItem('dates');
    window.sessionStorage.removeItem('aiQibDetails');

    window.sessionStorage.removeItem('dates');
    window.sessionStorage.removeItem('search_value');
    window.sessionStorage.removeItem('page_limit');
    window.sessionStorage.removeItem('direction');
    window.sessionStorage.removeItem('lastIframeURLBeforeLogout');
    window.sessionStorage.removeItem('selectedItem');
    window.sessionStorage.removeItem('itemLink');
    window.sessionStorage.removeItem('breadcrumbHistory');
  }

  isCloudUser(userInfo: UserInfo): boolean {
    let roles = userInfo.roles || [];
    return permissions['saas-acceptance'].some((role) => {
      if (roles && roles.includes(role)) {
        return true;
      }
    });
  }

  getHttpQibHeaders() {
    return {
      headers: new HttpHeaders({
        'qib-header': 'yes',
      }),
    };
  }

  openDocumentation(): void {
    const isCloud = this.appInfoService.isCloudEnvironment();
    const docsPath = isCloud ? this.docsService.getDocsUrl(DOCS_PATHS.CLOUD_GETTING_STARTED_FOGLIGHT) : this.docsService.getDocsUrl(DOCS_PATHS.ONPREM_GETTING_STARTED_FOGLIGHT);

    window.open(docsPath, '_blank');
  }

  openMcpInstallerDownload(): void {
    const version = this.appInfoService.getVersion();
    const normalizedVersion = version && typeof version === 'string' ? version.slice(0, -2) : '';
    const url = `https://support.quest.com/foglight/${normalizedVersion}/download-new-releases`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
